import { checkUserToken, setRedirectPage } from '../lib/OidcHelper';
import { deleteRemoteFave, setRemoteFaves } from '../lib/ApiHubHelper';
import { hideMessageboxModal, showMessageboxModal } from "./TripPlannerHelper";
import { initPreferenceFavourites } from '../components/PreferenceFavourites';


// initFavButton is called from a number of places including SearchSubmit.js when search results change.
function initFavButton() {

  const favButtonsExist = (!!$('.product-card__fav-btn') && $('.product-card__fav-btn').length > 0);

  if (favButtonsExist) {
    $('.product-card__fav-btn').off('click'); // remove any existing listeners.
    $('.product-card__fav-btn').on('click', onClickFav.bind(this));
    checkFaves();
  }
}

function onClickFav(event) {
  console.log('clicked a Fave.');
  let current = event.currentTarget;

  // Find the product ID by looking for the closest container with productid attribute
  let productContainer = current.closest('[productid]');
  let productid = productContainer ? productContainer.getAttribute('productid') : null;

  console.log('Found productid:', productid);

  if (!productid) {
    console.error('No product ID found for favorite button');
    return;
  }

  // Show modal if not logged in
  if (!isLoggedIn()) {
    console.log('not logged in. setRedirectPage and show modal');
    // This setRedirectPage call won't after we consolidate login process.
    setRedirectPage(); // So user returns to their current page after login.
    showMessageboxModal('#msgboxModalUpsell');
    return;
  }

  // check if product is faved before adding or removing product.
  if (checkProductFav(productid)) {
    console.log('remove fav');
    remoteRemoveProduct(productid); // remove product to remote if logged in.
    localRemoveProduct(productid);
  } else {
    console.log('add fav');
    remoteAddProduct(productid); // add product to remote if logged in.
    localAddProduct(productid);
  }
}

function checkProductFav(productid) {
  // Check if product is in localStorage (this is the source of truth)
  const faves = localStorageGetFaves();
  const isInLocalStorage = faves.includes(productid);

  // Also check DOM state - look for active favorite buttons within elements with this productid
  const activeFavBtn = document.querySelector(`[productid="${productid}"] .product-card__fav-btn.product-card__fav-btn--active`);
  const isDOMActive = !!activeFavBtn;

  // Return true if either localStorage contains the product OR DOM shows it as active
  // localStorage is the primary source of truth
  return isInLocalStorage || isDOMActive;
}

function localStorageGetFaves() { // returns faves array.
  const store = window.localStorage;
  //console.log("localStorageGetFaves", store);
  return JSON.parse(store.getItem('favourites')) || [];
}

function localAddProduct(productid) {
  let faves = localStorageGetFaves();
  if (faves.includes(productid)) { // check if already in store
    return;
  }
  faves.push(productid);
  const store = window.localStorage;
  store.setItem('favourites', JSON.stringify(faves));
  markFav(productid);

  // Refresh the favorites panel if we're on the preference centre page
  if (window.location.pathname.indexOf('preference-centre') !== -1) {
    console.log('Refreshing favorites panel after addition');
    initPreferenceFavourites();
  }
}

function localRemoveProduct(productid) {
  let faves = localStorageGetFaves();
  faves = faves.filter(item => item !== productid); // remove item from array
  const store = window.localStorage;
  store.setItem('favourites', JSON.stringify(faves));
  unmarkFav(productid);

  // Refresh the favorites panel if we're on the preference centre page
  if (window.location.pathname.indexOf('preference-centre') !== -1) {
    console.log('Refreshing favorites panel after removal');
    initPreferenceFavourites();
  }
}

function remoteAddProduct(productId) {

  console.log('in remoteAddProduct ');

  const token = checkUserToken(); // from OidcHelper.js

  // if logged in and have token
  // add productId to server via API
  if (!!token) {
    console.log('add to remote.');
    setRemoteFaves(token, productId);
  }
  if (!token) {
    console.log('No token. No add to remote.');
    prefCentreIsLoggedOut();
  }

}

function isLoggedIn() {
  const token = checkUserToken(); // from OidcHelper.js

  return !!token;
}

async function remoteRemoveProduct(productId) {

  const token = checkUserToken(); // from OidcHelper.js

  // console.log('remove DDDD token:', token);

  // if logged in and have token
  // remove productId from server via API
  if (!!token) {
    // console.log('remove from remote.');
    await deleteRemoteFave(token, productId);
  }
  if (!token) {
    // console.log('No token. No remove from remote.');
    prefCentreIsLoggedOut();
  }

}

function checkFaves() {
  // console.log("faves", "loaded");
  const faves = localStorageGetFaves();

  if (faves.length < 0) {
    return;
  }

  faves.forEach(id => {
    markFav(id);
  });
}

function markFav(productid) {
  //console.log('markFav', productid);
  // Find all favorite buttons within elements that have the exact productid
  let favEl = $(`[productid="${productid}"] .product-card__fav-btn`);

  // Only mark as favorite if we found the right element(s) for this productid
  if (favEl.length > 0) {
    favEl.addClass('product-card__fav-btn--active');
    // console.log(`Marked product ${productid} as favorite`);
  }
  // else {
  //   console.log(`fav button for product ${productid} not found on page.`);
  // }
}

function unmarkFav(productid) {
  // Find all favorite buttons within elements that have the exact productid
  let favEl = $(`[productid="${productid}"] .product-card__fav-btn`);

  // Only unmark favorite if we found the right element(s) for this productid
  if (favEl.length > 0) {
    favEl.removeClass('product-card__fav-btn--active');
    // console.log(`Unmarked product ${productid} as favorite`);
  } else {
    console.warn(`Could not find favorite button for product ${productid}`);
  }
}

function prefCentreIsLoggedOut() {
  // Shift the page to a logged out state.
  console.log('prefCentreIsLoggedOut cleanup');
  const store = window.localStorage;
  // delete old token and expiry
  store.removeItem('user_token');
  store.removeItem('user_expires_at');
  // if pref-centre page change panel to faves
  // if any other page? reload page once?
}

export { initFavButton, onClickFav, checkProductFav, localAddProduct, localStorageGetFaves, checkFaves, remoteAddProduct, remoteRemoveProduct };
